import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(req => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = 'Bearer ' + token;
  return req;
});

const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };

export default function MomentsPage() {
  const [moments, setMoments] = useState([]);
  const [newPost, setNewPost] = useState('');
  const [postLang, setPostLang] = useState('en');
  const [showPost, setShowPost] = useState(false);
  const [commentInput, setCommentInput] = useState({});
  const navigate = useNavigate();

  useEffect(() => { api.get('/moments').then(r => setMoments(r.data)).catch(() => {}); }, []);

  const postMoment = async () => {
    if (!newPost.trim()) return;
    try {
      await api.post('/moments', { text: newPost, lang: postLang });
      setNewPost(''); setShowPost(false);
      const r = await api.get('/moments');
      setMoments(r.data);
    } catch {}
  };

  const toggleLike = async (id) => {
    try {
      const r = await api.post(`/moments/${id}/like`);
      setMoments(prev => prev.map(m => m.id === id ? { ...m, likes: m.likes || [] } : m));
    } catch {}
  };

  const addComment = async (momentId) => {
    const text = commentInput[momentId];
    if (!text?.trim()) return;
    try {
      await api.post('/moments/' + momentId + '/comment', { text });
      setCommentInput(prev => ({ ...prev, [momentId]: '' }));
      const r = await api.get('/moments');
      setMoments(r.data);
    } catch {}
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>🌍 动态</h2>
        <p className="subtitle">和好友分享你的语言学习日常</p>
      </div>

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <button className="btn btn-primary" onClick={() => setShowPost(!showPost)}>
          {showPost ? '✕ 收起' : '📝 发动态'}
        </button>
      </div>

      {showPost && (
        <div className="card" style={{ margin: '0 auto 20px', maxWidth: 500 }}>
          <textarea value={newPost} onChange={e => setNewPost(e.target.value)} rows={3}
            placeholder="分享你的语言学习日常..." style={{ width: '100%', marginBottom: 10, padding: 12, background: 'var(--glass)', border: '1px solid var(--glass-border)', borderRadius: 12, color: 'var(--text)', fontFamily: 'inherit', outline: 'none' }} />
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <select value={postLang} onChange={e => setPostLang(e.target.value)}
              style={{ padding: '8px 12px', background: 'var(--glass)', border: '1px solid var(--glass-border)', borderRadius: 8, color: 'var(--text)' }}>
              <option value="en">🇺🇸 English</option><option value="zh">🇨🇳 中文</option>
              <option value="ja">🇯🇵 日本語</option><option value="ko">🇰🇷 한국어</option>
              <option value="es">🇪🇸 Español</option><option value="fr">🇫🇷 Français</option>
            </select>
            <button className="btn btn-primary" onClick={postMoment}>发布</button>
          </div>
        </div>
      )}

      <div className="moments-feed">
        {moments.map(m => {
          const isLiked = m.likes?.length > 0;
          return (
            <div key={m.id} className="moment-card">
              <div className="moment-header">
                <div className="moment-avatar">{m.username?.charAt(0)?.toUpperCase() || '?'}</div>
                <div>
                  <div className="moment-user">{FLAGS[m.country_code]||'🌍'} {m.username}</div>
                  <div className="moment-lang">{m.lang_name || m.lang} · {new Date(m.created_at).toLocaleDateString('zh-CN')}</div>
                </div>
              </div>
              <div className="moment-text">{m.text}</div>
              <div className="moment-lang-badge">{FLAGS[m.lang]||''} {m.lang?.toUpperCase()}</div>
              <div className="moment-actions">
                <button className={`moment-btn ${isLiked ? 'liked' : ''}`} onClick={() => toggleLike(m.id)}>
                  ❤️ {m.likes?.length || 0}
                </button>
                <span className="moment-btn">💬 {m.comments?.length || 0}</span>
              </div>
              {m.comments?.length > 0 && (
                <div className="moment-comments">
                  {m.comments.map(c => (
                    <div key={c.id} className="moment-comment">
                      <strong>{c.username || '?'}</strong> {c.text}
                    </div>
                  ))}
                </div>
              )}
              <div className="moment-comment-input">
                <input value={commentInput[m.id] || ''} onChange={e => setCommentInput(prev => ({ ...prev, [m.id]: e.target.value }))}
                  placeholder="写评论..." onKeyDown={e => e.key === 'Enter' && addComment(m.id)} />
                <button className="btn-send" onClick={() => addComment(m.id)} disabled={!commentInput[m.id]?.trim()}>➤</button>
              </div>
            </div>
          );
        })}
        {moments.length === 0 && (
          <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-dim)' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>📭</div>
            <p>还没有动态，去加些好友吧</p>
            <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={() => navigate('/discover')}>🌐 加好友</button>
          </div>
        )}
      </div>
    </div>
  );
}
